import React from 'react'
import './TodosEmpty.css';


function TodosEmpty() {
  return (
    <p>Crea tu primer TODO!!</p>
  )
}

export { TodosEmpty }